/* The trasseapp.com header for the older public pages restyled with
   legacy-v3.css: the trasse mark, Pricing, Sign in. */
import React from 'react';
import { Link } from 'react-router-dom';
import './legacy-v3.css';

const V3Head: React.FC = () => (
  <header className="v3-head">
    <Link to="/" className="v3-mark" aria-label="Trasse home">
      <svg width="28" height="28" viewBox="0 0 28 28" aria-hidden="true">
        <rect width="28" height="28" rx="7" fill="#0F1419" />
        <path d="M10 7.5v10.2c0 2.2 1.2 3.3 3.3 3.3H17M7.5 11.5H17" stroke="#F6F5F1" strokeWidth="2.6" fill="none" strokeLinecap="round" />
        <circle cx="20.5" cy="21" r="2.2" fill="#0FB8CE" />
      </svg>
      <b>trasse</b>
    </Link>
    <nav className="v3-links">
      <Link to="/pricing" className="v3-hide">Pricing</Link>
      <Link to="/sign-in">Sign in</Link>
    </nav>
  </header>
);

export default V3Head;
